import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const IcelandFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				width='20'
				height='14'
				rx='2'
				fill='white'
			/>
			<mask
				id='mask0_2332_15036'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					width='20'
					height='14'
					rx='2'
					fill='white'
				/>
			</mask>
			<g mask='url(#mask0_2332_15036)'>
				<rect
					width='20'
					height='14'
					fill='#0E4CB5'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 8.4H5.71429V14H8.57143V8.4H20V5.6H8.57143V0H5.71429V5.6H0V8.4Z'
					fill='white'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 7.46667H6.66667V14H7.61905V7.46667H20V6.53333H7.61905V0H6.66667V6.53333H0V7.46667Z'
					fill='#EB363A'
				/>
			</g>
		</svg>
	);
};

export default IcelandFlagIcon;
